import React from 'react';

const alumini = () => {
  return (
    <div>
      alumini
    </div>
  );
}

export default alumini;
